import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ImageCropperComponent} from 'ngx-image-cropper';

@Component({
  selector: 'app-img-cropper',
  templateUrl: './img-cropper.component.html',
  styleUrls: ['./img-cropper.component.css']
})
export class ImgCropperComponent implements OnInit {

  @Input() img: File;
  @Input() ratio: number;
  @Input() fileType: string;

  public img64: string;
  private imgCropped: string;
  public maintainAspectRatio = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
//    this.maintainAspectRatio = 'slide' === this.fileType;

    const reader = new FileReader();
    reader.readAsDataURL(this.img);
    reader.onload = (event: any) => {
      this.img64 = event.target.result;
    }
  }

  save() {
    this.activeModal.close(this.imgCropped);
  }

  imageCropped(cropped) {
    this.imgCropped = cropped;
  }

}
